interface PrivateObject {
  key: string;
  privateUrl: string;
}

interface PrivateUrlRequest {
  keys: string[];
  expireSec: number;
}

interface PrivateUrlResponse {
  QINIU: PrivateObject[];
  JD: PrivateObject[];
}

export const _getPrivateUrl = (params: PrivateUrlRequest): Promise<PrivateUrlResponse> =>
  fetch('/operator/oss/op/private_url/', {
    method: 'post',
    body: JSON.stringify(params),
    headers: { 'content-type': 'application/json; charset=UTF-8' },
  }).then(response => {
    if (response.ok) {
      return response.json().then(json => json.data);
    } else {
      return null;
    }
  });
